import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { RoomService } from "../../../../../../apps/resource-portal/src/app/services/room.service";
import { CommonUtils } from "../../../../../core/src/lib/utils/common.utils";
import { Subject, takeUntil } from "rxjs";
import { CutSheetService } from "apps/resource-portal/src/app/services/cut-sheet.service";
import { DialogService } from "libs/core/src/lib/services/dialog.service";
import { ProjectService } from "apps/resource-portal/src/app/services/project.service";

@Component({
  selector: "concourse-add-jsn-room",
  templateUrl: "./add-jsn-room.component.html",
  styleUrls: ["./add-jsn-room.component.scss"],
})
export class AddJsnRoomComponent implements OnInit {
  @Input() projectId;
  @Input() jsnId;
  @Input() jsnName;
  @Input() jsnOther;

  JSNForm: UntypedFormGroup;
  $unsubscribe = new Subject<void>();
  departments = [];
  roomTypes = [];
  roomNames = [];
  selectedDepartment = null;
  selectedRoom = null;
  sortColumn: string = null;
  rooms = [];
  roomContentList: UntypedFormArray = new UntypedFormArray([]);
  assignTo = [];
  project = null;
  selectedItems: string[] = [];
  isOpen = false;
  constructor(
    private _roomService: RoomService,
    public activeModal: NgbActiveModal,
    public _dialogService: DialogService,
    public _cutSheetService: CutSheetService,
    public _projectService: ProjectService
  ) {}

  ngOnInit(): void {
    this.JSNForm = new UntypedFormGroup({
      department: new UntypedFormControl("", [Validators.required]),
      roomtype: new UntypedFormControl(""),
      roomname: new UntypedFormControl(""),
      room: new UntypedFormControl("", [Validators.required]),
    });
    this.getAllDepartments(this.projectId);
  }

  getAllDepartments(projectId: string) {
    // this.selectedDepartment = null;

    this._roomService
      .getDepartmentByProjectId(projectId)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.departments = result || [];
          this.departments = CommonUtils.sortByKey(
            this.departments,
            "departmentname"
          );
          if (this.departments.length) {
            if (!this.selectedDepartment) {
              this.rooms = [];
            } else {
              this.getRoomType(this.selectedDepartment);
              this.getRoomName(this.selectedDepartment);
            }
          } else {
            this.selectedDepartment = null;
          }
          this.selectedItems = [];
          console.log("Selected DEPARTMENT: ", this.selectedDepartment);
          if (this.selectedDepartment != null) {
            this.getAllMiscContacts(this.selectedDepartment);
          }
        }
      });
  }

  changeDepartment(departmentId: string) {
    this.selectedDepartment = departmentId;
    if (this.selectedDepartment === "ALL") {
      this.getAllRooms(this.selectedDepartment);
      this.getRoomType("00000000-0000-0000-0000-000000000000");
      this.getRoomName("00000000-0000-0000-0000-000000000000");
    } else {
      this.getAllRooms(this.selectedDepartment);
      this.getRoomType(this.selectedDepartment);
      this.getRoomName(this.selectedDepartment);
    }
  }

  sortByColumn(columnName, order) {
    this.sortColumn = columnName;
    let sortedArray = this.roomContentList.value;
    sortedArray = CommonUtils.sortByKey(
      sortedArray,
      columnName,
      order ? "ASC" : "DESC"
    );
    this.roomContentList.setValue(sortedArray);
  }

  getRoomType(departmentId: any) {
    this.selectedDepartment = departmentId;
    if (this.selectedDepartment) {
      if (this.selectedDepartment !== "ALL") {
        this._roomService
          .getRoomsType(this.selectedDepartment, this.projectId)
          .pipe(takeUntil(this.$unsubscribe))
          .subscribe((result) => {
            if (result) {
              this.roomTypes = result || [];
            } else {
              this.roomTypes = [];
            }
          });
      }
    }
  }

  getRoomName(departmentId: any) {
    this.selectedDepartment = departmentId;
    if (this.selectedDepartment) {
      if (this.selectedDepartment !== "ALL") {
        this._roomService
          .getRoomsName(this.selectedDepartment, this.projectId)
          .pipe(takeUntil(this.$unsubscribe))
          .subscribe((result) => {
            if (result) {
              this.roomNames = result || [];
            } else {
              this.roomNames = [];
            }
          });
      }
    }
  }

  getAllRooms(departmentId: any) {
    this.selectedDepartment = departmentId;
    if (this.selectedDepartment) {
      if (this.selectedDepartment === "ALL") {
        /* this._roomService
          .getRoomsByProjectId(this.projectId)
          .pipe(takeUntil(this.$unsubscribe))
          .subscribe((result) => {
            if (result) {
              this.rooms = result || [];
              this.rooms = CommonUtils.sortByKey(this.rooms, "name");
              this.rooms = this.rooms?.map((item) => ({
                ...item,
                fullLabel: `${item.name}` + " (" + `${item.roomname}` + ")",
              }));

              if (this.rooms.length) {
                if (!this.selectedRoom) {
                  this.selectedRoom = this.rooms[0].id;
                }
              } else {
                this.selectedRoom = null;
              }
            }
          }); */
        const roomName = this.JSNForm.value.roomname;
        const roomType = this.JSNForm.value.roomtype;
        const projectId = this.projectId;
        this._roomService
          .getRoomByTypeCodeDepartmentId(
            false,
            roomName,
            roomType,
            "ALL",
            projectId
          )
          .pipe(takeUntil(this.$unsubscribe))
          .subscribe((result) => {
            if (result) {
              this.rooms = result || [];
              this.rooms = CommonUtils.sortByKey(this.rooms, "name");
              this.rooms = this.rooms?.map((item) => ({
                ...item,
                fullLabel: `${item.name}` + " (" + `${item.roomname}` + ")",
              }));
              if (this.rooms.length) {
                if (!this.selectedRoom) {
                  this.selectedRoom = this.rooms[0].id;
                }
              } else {
                this.selectedRoom = null;
              }
            }
          });
        this.getRoomName(this.selectedDepartment);
        this.getRoomType(this.selectedDepartment);
      } else {
        const roomName = this.JSNForm.value.roomname;
        const roomType = this.JSNForm.value.roomtype;
        const projectId = this.projectId;
        this._roomService
          .getRoomByTypeCodeDepartmentId(
            false,
            roomName,
            roomType,
            this.selectedDepartment,
            projectId
          )
          .pipe(takeUntil(this.$unsubscribe))
          .subscribe((result) => {
            if (result) {
              this.rooms = result || [];
              this.rooms = CommonUtils.sortByKey(this.rooms, "name");
              // this.rooms = this.rooms?.map((item) => ({
              //   ...item,
              //   fullLabel: `${item.name}` + " (" + `${item.roomname}` + ")",
              // }));
              if (this.rooms.length) {
                if (!this.selectedRoom) {
                  this.selectedRoom = this.rooms[0].id;
                }
              } else {
                this.selectedRoom = null;
              }
            }
          });
      }
    } else {
      this.rooms = [];
    }
  }

  getAllMiscContacts(departmentId) {
    this._roomService
      .getAllMiscContacts(departmentId)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((res) => {
        this.assignTo = res;
      });
  }
  saveJSNToRoom() {
    let filterValue = [];

    this.selectedItems.forEach((obj: any, index: number) => {
      const quantityInput = document.querySelector(
        `.qty-${index}`
      ) as HTMLInputElement;
      filterValue.push({
        id: obj.id,
        quantity: +quantityInput.value,
      });
    });
    const payload = {
      jsn: this.jsnId,
      jsnother: this.jsnOther,
      project: this.projectId,
      roomlist: filterValue,
    };
    if (this.JSNForm.valid) {
      this._cutSheetService
        .addJSNToMultipleRooms(payload)
        .pipe(takeUntil(this.$unsubscribe))
        .subscribe((res) => {
          if (res?.status == 200) {
            this.activeModal.close();
            this._dialogService.showToast(
              "Updates must be approved before they will appear",
              "success"
            );
            this.getProjectDetails(this.projectId);
          } else if (res?.status == 400) {
            this._dialogService.showToast(
              "This JSN already exists in the Room.",
              "error"
            );
          } else {
            this._dialogService.showToast(
              "Unable to Add JSN to the Project",
              "error"
            );
          }
        });
    } else {
      this._dialogService.showToast(
        "Please ensure all the fields are correct."
      );
    }
  }

  getProjectDetails(projectId: string) {
    this._projectService
      .getProjectDetails(projectId)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.project = result || null;
          this._cutSheetService.isJsnAddedToRooms.next({
            projectId: this.projectId,
            projectname: this.project?.projectname,
            departmentId: this.selectedDepartment,
          });
        }
      });
  }

  isSelected(room: any): boolean {
    return this.selectedItems.includes(room);
  }

  onCheckboxChange(room: any, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.addValue(room);
    } else {
      this.removeValue(room);
    }
  }

  addValue(room: any) {
    if (!this.selectedItems.includes(room)) {
      this.selectedItems.push(room);
    }
  }

  removeValue(room: any) {
    this.selectedItems = this.selectedItems.filter((item) => item !== room);
  }

  isAllSelected(): boolean {
    return this.rooms.length === this.selectedItems.length;
  }

  toggleSelectAll(event: any): void {
    if (event.target.checked) {
      this.selectedItems = [...this.rooms];
    } else {
      this.selectedItems = [];
    }
  }
}
